import { FolderOutlined, FolderSharedOutlined } from '@mui/icons-material';
import { SxProps } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import { useAuth } from '../../components/Providers/AuthProvider';
import { Folder } from '../../Types/folder';

type FolderIconProps = {
  currentFolder: Folder;
  customStyles?: SxProps;
};

const FolderIcon = ({ currentFolder, customStyles }: FolderIconProps): JSX.Element => {
  const { currentUser } = useAuth();
  const isOwner = currentFolder.ownerId === currentUser?.id;
  const hasContributors = currentFolder.contributors.length > 0;
  const isPinned = currentFolder.pinned;

  if (isOwner && hasContributors) {
    return isPinned ? (
      <Tooltip title="Pinned & Owned By Me">
        <FolderSharedOutlined sx={{ color: '#F900D3', ...customStyles }} />
      </Tooltip>
    ) : (
      <Tooltip title="Owned By Me">
        <FolderSharedOutlined sx={{ color: '#070154', ...customStyles }} />
      </Tooltip>
    );
  }

  return isPinned ? (
    <Tooltip title="Pinned">
      <FolderOutlined sx={{ color: '#F900D3', ...customStyles }} />
    </Tooltip>
  ) : (
    <FolderOutlined sx={{ color: '#070154', ...customStyles }} />
  );
};

export default FolderIcon;
